import * as React from 'react';
import { CategoryIcon } from 'common--design-library';
import { translation } from 'easit--localization';

export interface ISportItem {
    categoryId: number;
    graphicsPresentationId: number;
    label: string;
}

export interface ISportSelectionProps {
    selectedSports?: number[];
    sports: ISportItem[];
    selectSport: (sportCategoryId: number) => void;
    favoritesCategoryId: number | null;
    videosCategoryId: number | null;
    matchTrackersCategoryId: number | null;
    className?: string;
    isPinnedOnMobile?: boolean;
}

const renderSports = (props: ISportSelectionProps, roleForTest: string) => {

    return props.sports && props.sports.length > 0
        ? props.sports.map((item) => {
            let isSelected = props.selectedSports.indexOf(item.categoryId) >= 0;
            return <SportSelectionIcon key={item.categoryId}
                item={item}
                isItemSelected={isSelected}
                selectSport={props.selectSport}
                selectedSports={props.selectedSports}
                favoritesCategoryId={props.favoritesCategoryId}
                videosCategoryId={props.videosCategoryId}
                matchTrackersCategoryId={props.matchTrackersCategoryId}
                roleForTest={roleForTest}
            />
        })
        : null
}

export const SportSelection: React.FC<ISportSelectionProps> = (props: ISportSelectionProps) => {
    const roleForTest = "sports-filter";
    return <div className={`sport-selection `} data-test-role={roleForTest} > {renderSports(props, roleForTest)}</div>
}

export interface ISportSelectionIconProps {
    item: ISportItem;
    isItemSelected: boolean;
    selectedSports: number[];
    favoritesCategoryId: number | null;
    videosCategoryId: number | null;
    matchTrackersCategoryId: number | null;
    selectSport: (sportCategoryId: number) => void;
    roleForTest?: string;
}

export const SportSelectionIcon: React.FC<ISportSelectionIconProps> = (props: ISportSelectionIconProps) => {

    let isVideo = props.item.categoryId === props.videosCategoryId;

    return <div key={props.item.categoryId}
        className={`sport-item ${isVideo ? "with-badge" : null} ${props.selectedSports && props.isItemSelected ? 'selected' : 'unselected'} `}
        onClick={() => props.selectSport(props.item.categoryId)}
        data-test-role={props.roleForTest ? `${props.roleForTest}__item` : undefined}
    >{isVideo && <span className="new-badge">{translation().flag_new}</span>}
        {
            props.item.categoryId === props.favoritesCategoryId
                ? <span className="far fa-star favorites-icon"></span>
                : props.item.categoryId === props.videosCategoryId
                    ? <span className="fa fa-desktop favorites-icon"></span>
                    : props.item.categoryId === props.matchTrackersCategoryId
                        ? <span className="fa fa-eye favorites-icon"></span>
                        : <CategoryIcon categoryIconId={props.item.graphicsPresentationId} />
        }

        <div className="sport-label">
            {props.item.label}
        </div>
    </div>
}